import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  button: {
    flex: 1,
  },
});

export default styles;
